import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import getReducersLayout from "../utils/getReducersLayout";
import { ICoinflipGame, ICoinflipState } from "@api/types/Coinflip";

const initialState: ICoinflipState = {};

export const initialCoinflipGame: ICoinflipGame = {
  // id: "",
  game_metadata: {
    creator: {
      uid: "",
      username: "",
      is_staff: false,
      avatar_url: "",
      id: "",
    },
    created_at: 0,
    status: "finished",
    started_at: 0,
    ended_at: 0,
    max_players: 2,
    is_private: false,
  },
  uid: "",
  tails_user: {
    uid: "",
    username: "",
    is_staff: false,
    avatar_url: "",
    id: "",
    expirience: 0,
  },
  heads_user: {
    uid: "`",
    username: "",
    is_staff: false,
    avatar_url: "",
    id: "",
    expirience: 0,
  },
  stake: 0,
  reward: 0,
  roll: 0,
  result: "tails",
  ticket_id: "",
  ticket_hash: "",
  ticket_verify_url: "",
};

const coinflipSlice = createSlice({
  initialState,
  name: "coinflipData",
  reducers: {
    ...getReducersLayout<ICoinflipState>(initialState),
    addCoinflipoGame: (
      state,
      action: PayloadAction<{ game: ICoinflipGame }>
    ) => {
      state[action.payload.game.uid] = {
        ...action.payload.game,
      };
    },
    updateSingleCoinflipGame: (
      state: ICoinflipState,
      action: PayloadAction<{ game: ICoinflipGame }>
    ) => {
      state[action.payload.game.uid] = {
        ...action.payload.game,
      };
    },
    removeSingleCoinflipGame: (
      state: ICoinflipState,
      action: PayloadAction<{ gameUid: string }>
    ) => {
      delete state[action.payload.gameUid];
    },
  },
});

export const {
  setData,
  resetData,
  addCoinflipoGame,
  updateSingleCoinflipGame,
  removeSingleCoinflipGame,
} = coinflipSlice.actions;
export default coinflipSlice;
